import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { CompanyStoreMail } from '~/models/CompanyStoreMail';

const paths = {
  index: '/company_store_mails'
};

type TIndex = () => SwrReturnType<CompanyStoreMail[]>;
type ReturnType = {
  index: TIndex;
};

export const useCompanyStoreMails = (): ReturnType => {
  const index: TIndex = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<CompanyStoreMail[]>(paths.index);
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
